export default __webpack_public_path__ + "static/media/39.a8ba0125.jpg";